module.exports = __webpack_public_path__ + "static/img/login.4d95c995.jpg";